module.exports = __webpack_public_path__ + "static/media/moon.1b73a852.svg";